import { store } from '@/store/index'

function isEmpty(obj) {
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false
    }
  }
  return true
}

export default async () => {
  if (
    store.getters.mainStore === undefined ||
    !store.getters.mainStore ||
    isEmpty(store.getters.mainStore)
  ) {
    const main_store = store.state.outlet.main_store
    const store_id = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_store_id')
    if (store_id && (main_store === null || main_store === undefined || isEmpty(main_store))) {
      await store.dispatch('fetchOutlet', { params: store_id, isSetMainStore: true })
    }
  }
}
